import { styled } from '@mui/material'
import { Warning as WarningIcon, Close as CloseIcon } from '@mui/icons-material'

export const DialogIcon = styled(WarningIcon)`
  color: ${props => props.theme.palette.brand.warning};

  &.MuiSvgIcon-root {
    font-size: 2em;
  }
`

export const CloseDialogIcon = styled(CloseIcon)`
  color: ${props => props.theme.palette.brand.black1};
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  &.MuiSvgIcon-root {
    font-size: 1.6em;
  }
`
export const DialogContainer = styled('div')`
  position: relative;
  padding: 24px;
  background-color: ${props => props.theme.palette.yellow[95]};
`

export const DialogContent = styled('div')`
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  position: relative;
  display: flex;
`

export const DialogText = styled('div')`
  margin-left: 32px;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }

  &:visited {
    color: ${props => props.theme.palette.brand.primary};
  }
`
export const Strong = styled('strong')``
